// extracted by mini-css-extract-plugin
module.exports = {"key":"key___1sfQr","value":"value___3FPTM","icons":"icons___1u40N"};